// extracted by mini-css-extract-plugin
export var page_nav = "PageNav-module--page_nav--lAGla";
export var page_nav__button = "PageNav-module--page_nav__button--kEd6m";